$ = jQuery;
$(document).ready(function () {
  const miniatures = $('.secours-actions_miniatures_box');
  const actionContainer = $('.action');

  miniatures.on('click', function () {
    $('.secours-actions_miniatures_box').removeClass('active');
    $(this).addClass('active');
    let containerId = $(this).attr('data-number');
    actionContainer.removeClass('active');
    $('#secours-actions-slide' + containerId).addClass('active');
  });

  // Clone du text pour défiler
  const originalText = $('.bg-move').text();
  let counter = 0;
  const maxLimit = 15;

  const intervalId = setInterval(() => {
    if (counter < maxLimit) {
      $('.bg-move').append(originalText);
      counter++;
    } else {
      clearInterval(intervalId);
    }
  }, 100);
});
// defilement texte on scroll
$(window).on('load resize scroll', function () {
  $('.bg-static').each(function () {
    var windowTop = $(window).scrollTop();
    var elementTop = $(this).offset().top;
    var leftPosition = windowTop - elementTop;
    $(this).find('.bg-move').css({ left: leftPosition });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  var splide = new Splide('#secours-actions-progress', {
    perPage: 3,
    type: 'carousel',
    perMove: 1,
    padding: { left: 0, right: '6em' },
    pagination: false,
    gap: 30,
    breakpoints: {
      640: {
        perPage: 1,
      },
    },
  });

  splide.mount();

  var splideActions = new Splide('#secours-actions', {
    perPage: 1,
    type: 'carousel',
    pagination: true,
    arrows: false,
    gap: 30,
    mediaQuery: 'min',
    breakpoints: {
      1025: {
        destroy: true,
      },
    },
  });

  splideActions.mount();
});
